<template>    
  <div>
    <!-- <div class="container d-flex flex-column"> -->
    <div class="container-fluid">  
      <!--<div class="row align-items-center justify-content-center no-gutters min-vh-100">-->
      <div class="row align-items-center justify-content-center no-gutters min-vh-100">
        <div class="col-12 col-md-6 col-lg-3 px-8 px-lg-8 px-xl-8 px-xxl-12 py-8 py-md-11">
          <div class="text-center pb-8 pl-4">
            <b-img src="../assets/orange-logo-small.png" alt="Logo Orange" fluid />
          </div>
          <!-- Heading -->
          <h1 class="mb-0 fw-bold text-center text-dark">
            {{$t('h1Login')}}
          </h1>
          <!-- Form -->
          <form class="my-8">
              <button v-on:click.prevent="siginSOO()" class="btn btn-primary btn-block" type="submit">
              Autentícate
              </button>
            <!-- Submit -->
          </form>
          <!-- Login -->
        </div>
        <div class="col-lg-8 offset-lg-1 align-self-stretch d-none d-lg-block">
          <!-- Image -->
                <div class="h-100 w-cover bg-cover" :style="{'background-image': 'url(' + backgroundImage1 +')'}"></div>
          <!-- Shape -->
          <!--<div class="shape shape-left shape-fluid-y svg-shim text-white">-->
            <div class="shape shape-left shape-fluid-y text-white">
            <svg viewBox="0 0 100 1544" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0H100V386L50 1158V1544H0V0Z" fill="currentColor"/>
            </svg>
          </div>
        </div>
      </div> <!-- / .row -->
    </div> <!-- / .container -->
  </div>   
</template>

<script>

//import auth from '../auth.js';
//import {signIn, signOut} from '../authPopup.js';F
import {signIn, signOut} from '../authRedirect.js';

export default {

  data() {
    return {
      id1: 'LoginPicture',
      resultadoEnvio: '',
      conjuntoIdiomas: [
          { value: null, text: 'Please select language'},
          { value: 'en', text: 'English'},
          { value: 'es', text: 'Spanish'}
      ],
      idioma: null
    }
  },
  computed: {
      backgroundImage1 () {    
        return require('../assets/' + this.id1 + '.png');  
      },
  },
  mounted() {},
  methods: {
    siginSOO(){
      signIn().then(() => {
      }).catch(error => {
        // Manejar errores de autenticación, si es necesario
        console.error("Error de autenticación:", error);
      });
    },
    sigOutSOO(){
      // Desconectamos de SSO de MS
      signOut();
    },
    cambiarIdioma() {
        this.$i18n.locale = this.idioma
      }
   }
}
</script>